module.exports = __webpack_public_path__ + "static/media/Brannbil.cd582f9e.mp3";